import Vue from 'vue';

export function checkLogin(context, msg, redirectUrl) {
    let loginName = Vue.ls.get('token');
    if (!loginName) {
        context.$router.push({
            name: 'login',
            query: { tip: 1, msg: msg, redirectUrl: redirectUrl },
        });
    }
}